export async function readLayerNotes(layerId: string): Promise<string | null> {
  return window.api.layerNotesRead(layerId);
}
